import * as types from '../mutation-types';
import {
    getUserInfo
} from '@/api/account';
import {
    createJsapiSignature
} from '@/api/app';
import jsonp from 'jsonp';
import {
    Toast
} from "vant";
import wx from 'weixin-js-sdk';

import { hhLogo , link } from "@/common/utils/share-img";

const comp = {
    namespaced: true,
    state: {
        postLoading: false,
        userInfo: {},
        cities: {},
        share: {},
        showApp:true
    },
    mutations: {
        [types.POST_LOADING](state, status) {

            state.postLoading = status;
            // console.log('loading====', state.postLoading);
        },
        [types.SHOW_APP](state, status) {
            state.showApp = status;
        },
        [types.COMP_USERINFO](state, status) {
            //console.log("status",status);
            state.userInfo = status;
        },
        [types.COMP_CITIES](state, data) {

            state.cities = data;
            window.METADATA = {
                ...window.METADATA,
                ...data
            };
            window.METADATA.areaList = {
                province_list: {},
                city_list: {}
            }
            let province = window.METADATA.province;
            let citys = window.METADATA.citys;
            province.forEach(p => {
                let ids = p.id;
                window.METADATA.areaList.city_list[ids] = [];
                if (p.citys.length > 0) {
                    let crr = p.citys;
                    crr.forEach(item => {
                        window.METADATA.areaList.city_list[ids].push(citys[item])
                    });
                }
            });
            Toast.clear();
            state.postLoading = false;
        },
        [types.WX_SHARE](state, data ){
            if(!Object.keys(state.share).length){ //初始化
                state.share = { ...data };
            };
            if(Object.keys(data).length){
                let newShare = { ...state.share, ...data };
                console.log('进频道设置分享',newShare)
                if(window.location.href.indexOf('isShare') > -1){
                    wx.hideAllNonBaseMenuItem();
                }else{
                    wx.onMenuShareTimeline(newShare);
                    wx.onMenuShareAppMessage(newShare);
                }
            }else{
                console.log('进频道默认分享', state.share)
                if(window.location.href.indexOf('isShare') > -1){
                    wx.hideAllNonBaseMenuItem();
                }else{
                    wx.onMenuShareTimeline(state.share);
                    wx.onMenuShareAppMessage(state.share);
                }
            }
            
            //在main.js里 after router 重置回默认;
        }
    },
    actions: {
        [types.COMP_USERINFO]({
            commit
        }) { //context.commit
            commit(types.SHOW_APP, false);
            getUserInfo().then(res => {
                //debugger;
                res.data._loadedUserInfo = true;
                commit(types.SHOW_APP, true);
                commit(types.COMP_USERINFO, res.data);
                commit(types.SHOW_APP, true);
            }).catch(err => {
                commit(types.SHOW_APP, true);
            });
        },
        [types.COMP_CITIES]({
            commit
        }) {
            commit(types.POST_LOADING, true);
            jsonp('//boot-restful.hunteron.com/metadata/getMetadata', {
                callback: 'metadataIndustry'
            }, (err, data) => {
                commit(types.COMP_CITIES, data , true);
            });
        },
        [types.WX_SHARE]({
            commit
        }) {
            let _url = window.location.href;
            
            commit(types.SHOW_APP, false);
            createJsapiSignature({
                url: _url
            }).then(res => {
                let d = res.data;
                
                wx.config({
                    debug: false,
                    appId: d.appId,
                    timestamp: d.timestamp,
                    nonceStr: d.nonceStr,
                    signature: d.signature,
                    jsApiList: ['chooseImage', 'uploadImage', 'previewImage', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseWXPay', 'hideAllNonBaseMenuItem', 'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice']
                });
                wx.ready( function(){
                    let default_share = {
                        title: '猎上 - 重新定义人才服务',
                        link: link,
                        imgUrl: hhLogo,
                        desc: '',
                        success: function () {
                            
                        },
                        cancel: function () {}
                    }
                    commit(types.SHOW_APP, true);
                    commit(types.WX_SHARE,default_share)
                });
            }).catch(err => {
                commit(types.SHOW_APP, true);
            });
        }
    },
    getters: {
        getPostLoading: state => state.postLoading,
        getUserInfo: state => state.userInfo,
        getCities: state => state.cities,
        getWxShare: state => state.share,
        getShowApp: state => state.showApp
    }
}

export default comp;